import React, { Component, useEffect, useState } from 'react'
// import axios from 'axios'
// import {generateTempArray} from '../../utilities/common-helpers'
// import { ProductGroupWithCarousel } from '../../components/partials/product/ProductGroupWithCarousel';


// import ShopItems from '../../components/partials/shop/ShopItems';
import FormNewCustomer from '../../components/shared/forms/form-new-customer';


const Link = require("react-router-dom").Link

const AdminCustomerNewPage = () => {


  useEffect(() => {
    // getProducts();
  }, []);


  return (

        <section className="ps-my-account ps-page--account">
            <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="ps-page__content">
                      <FormNewCustomer/>
                    </div>
                  </div>
                </div>



                <div style={{height: '5vh'}}/>


            </div>
        </section>

  );

}


export default AdminCustomerNewPage;
